<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="fleetInfoForm">
        <div class="my-section-box__headline">{{ 'common.value_calculator_flit_info_title' | cxTranslate }}</div>
        <div class="my-section-box fleetInfo" id="fleetInfo">
          <div class="my-section-box-inner fleet-info-block">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <label class="form-label" for="numOfVechicles">{{ 'common.text_smartire_numberof_vahicles' |
                cxTranslate }}</label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-sm-6 pr-0">
                    <input class="fleet-info-input" type="text" formControlName="numOfVechicles" />
                    @if (form.numOfVechicles.invalid && (form.numOfVechicles.dirty || form.numOfVechicles.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-6 pl-1 EnduTooltip">
                    {{ 'common.text_smartire_vehicles' | cxTranslate }}
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="avgVechicles">{{ 'common.text_smartire_average_mileage' |
                cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" class="fleet-info-input" formControlName="avgVechicles" />
                    @if (form.avgVechicles.invalid && (form.avgVechicles.dirty || form.avgVechicles.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EnduTooltip">
                    {{ 'common.text_smartire_per_year' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="tierPerVechicles">{{ 'common.text_smartire_numberof_tires' |
                cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" class="fleet-info-input" formControlName="tierPerVechicles" />
                    @if (form.tierPerVechicles.invalid && (form.tierPerVechicles.dirty || form.tierPerVechicles.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EnduTooltip">
                    {{ 'common.text_smartire_tires' | cxTranslate }}
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="tireInspection">{{ 'common.text_smartire_tire_inspection' |
                cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" class="fleet-info-input" formControlName="tireInspection" />
                    @if (form.tireInspection.invalid && (form.tireInspection.dirty || form.tireInspection.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EnduTooltip">
                    {{ 'common.text_smartire_per_month' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <label class="form-label" for="avgUnderInflation">{{ 'common.text_smartire_average_under_inflation' |
                cxTranslate }}</label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-sm-6 pr-0">
                    <input class="fleet-info-input" type="text" formControlName="avgUnderInflation" />
                    @if (form.avgUnderInflation.invalid && (form.avgUnderInflation.dirty || form.avgUnderInflation.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-6 pl-1 EnduTooltip">
                    %
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="tireLife">{{ 'common.text_smartire_tire_life' |
                cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" class="fleet-info-input" formControlName="tireLife" />
                    @if (form.tireLife.invalid && (form.tireLife.dirty || form.tireLife.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-6 EnduTooltip">
                    {{ 'common.text_smartire_miles' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="downtimeInstance">{{ 'common.text_smartire_average_anual_downtime' |
                cxTranslate }}</label>
                <div class="row">
                  <div class="col-6 row">
                    <div class="col-8 col-sm-4 pr-0">
                      <input type="number" class="fleet-info-input" formControlName="downtimeInstance" />
                    </div>
                    <div class="col-4 col-sm-8 EnduTooltip noWrap">
                      {{ 'common.text_smartire_instance' | cxTranslate }}
                    </div>
                    @if (form.downtimeInstance.invalid && (form.downtimeInstance.dirty || form.downtimeInstance.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-6 row">
                    <div class="col-8 col-sm-4 pl-0">
                      <input type="number" class="fleet-info-input" formControlName="downtimeInstanceForVechicles" />
                    </div>
                    <div class="col-4 col-sm-8 EnduTooltip">
                      {{ 'common.text_smartire_vehicles' | cxTranslate }}
                    </div>
                    @if (form.downtimeInstanceForVechicles.invalid && (form.downtimeInstanceForVechicles.dirty || form.downtimeInstanceForVechicles.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
                <label class="form-label" for="fuelConsumption">{{ 'common.text_smartire_fuel_cunsumption' |
                cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" class="fleet-info-input" formControlName="fuelConsumption" />
                    @if (form.fuelConsumption.invalid && (form.fuelConsumption.dirty || form.fuelConsumption.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.text_smartire_error_numeric'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EnduTooltip">
                    {{ 'common.text_smartire_usd_per_gallon' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="airdisk-button-block">
              <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn col-6"
                (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow" alt="">
              {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
              <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn col-6"
                (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>